// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Inter";
}

.styles_notificacao__ancora__xsELH {
  text-decoration: none;
  color: #18316e;
  cursor: pointer;
}

.styles_notificacao__module__x7-o2 {
  width: 30rem;
  height: 7rem;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: #fff;
  transition: all 0.3s ease-in-out;
}

.styles_notifications__texts__Nie6H {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}

.styles_notifications__texts__Nie6H span {
  font-weight: 300;
}

.styles_line_one__SGxvu {
  display: flex;
  justify-content: space-between;
}

.styles_line_one__SGxvu h1 {
  font-weight: 500;
  font-size: 1rem;
}

.styles_notificacao__module__x7-o2:hover {
  background-color: #d8d8d8;
}

.styles_notificacao__texts__VeKyA {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
}

.styles_notificacao__date__O-20b {
  box-sizing: border-box;
  right: 1.7rem;
  font-weight: 300;
  font-size: 0.8rem;
  color: #18316e;
}

@media (max-width: 475px) {

  .styles_notificacao__module__x7-o2 {
    width: 23rem;
    height: 7rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Notificacao/styles.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE;IACE,YAAY;IACZ,YAAY;EACd;AACF","sourcesContent":["* {\n  font-family: \"Inter\";\n}\n\n.notificacao__ancora {\n  text-decoration: none;\n  color: #18316e;\n  cursor: pointer;\n}\n\n.notificacao__module {\n  width: 30rem;\n  height: 7rem;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  background-color: #fff;\n  transition: all 0.3s ease-in-out;\n}\n\n.notifications__texts {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.notifications__texts span {\n  font-weight: 300;\n}\n\n.line_one {\n  display: flex;\n  justify-content: space-between;\n}\n\n.line_one h1 {\n  font-weight: 500;\n  font-size: 1rem;\n}\n\n.notificacao__module:hover {\n  background-color: #d8d8d8;\n}\n\n.notificacao__texts {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.notificacao__date {\n  box-sizing: border-box;\n  right: 1.7rem;\n  font-weight: 300;\n  font-size: 0.8rem;\n  color: #18316e;\n}\n\n@media (max-width: 475px) {\n\n  .notificacao__module {\n    width: 23rem;\n    height: 7rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificacao__ancora": `styles_notificacao__ancora__xsELH`,
	"notificacao__module": `styles_notificacao__module__x7-o2`,
	"notifications__texts": `styles_notifications__texts__Nie6H`,
	"line_one": `styles_line_one__SGxvu`,
	"notificacao__texts": `styles_notificacao__texts__VeKyA`,
	"notificacao__date": `styles_notificacao__date__O-20b`
};
export default ___CSS_LOADER_EXPORT___;
